export default __webpack_public_path__ + "static/media/bigodinho.73f67226.jpg";